import { el } from "../utils/dom.ts";

// Reusable provenance badge. Every intelligence panel labels whether its data is
// a media signal (news-derived) or an official statistic — mandatory positioning
// so leadership never mistakes a media signal for an official number.
export type SignalSource = "media" | "official" | "market";

const LABELS: Record<SignalSource, { text: string; title: string }> = {
  media: {
    text: "📡 Tín hiệu truyền thông",
    title: "Dữ liệu suy ra từ tin báo chí — phản ánh mức độ đưa tin, không phải số liệu thống kê chính thức.",
  },
  official: {
    text: "🏛 Nguồn chính thống",
    title: "Số liệu từ cơ quan chính thống (GSO / bộ ngành), nhập thủ công.",
  },
  market: {
    text: "🏷 Tín hiệu thị trường (giá rao)",
    title: "Trung vị GIÁ RAO từ tin đăng bất động sản — không phải giá giao dịch thực tế.",
  },
};

export function signalSourceLabel(source: SignalSource): HTMLElement {
  const { text, title } = LABELS[source];
  return el("span", { className: `signal-label signal-${source}`, title }, [text]);
}
